import * as tslib_1 from "tslib";
import { LayerApi } from '../api/layer-api';
//import { NodeType } from '../classes/tree/IBaseNode';
import { NearbyAssetNode } from '../classes/tree/nodes/NearbyAssetNode';
import { environment } from '../environment';
import { BufferService } from '../services/buffer.service';
import { DocumentService } from '../services/document.service';
import { LayerService } from '../services/layer.service';
import { SpatialQueryService } from '../services/spatialQuery.service';
import { ToSqlStringService } from '../services/to-sql-string.service';
import * as i0 from "@angular/core";
import * as i1 from "./buffer.service";
import * as i2 from "../api/layer-api";
import * as i3 from "./layer.service";
import * as i4 from "./spatialQuery.service";
import * as i5 from "./to-sql-string.service";
import * as i6 from "./document.service";
var NearbyService = /** @class */ (function () {
    function NearbyService(bufferService, layerApi, layerService, spatialQueryService, toSqlStringService, documentService) {
        this.bufferService = bufferService;
        this.layerApi = layerApi;
        this.layerService = layerService;
        this.spatialQueryService = spatialQueryService;
        this.toSqlStringService = toSqlStringService;
        this.documentService = documentService;
        this.maxRecordsFetched = 100000;
        this.nearbyQueryName = 'NEARBY';
        this.bufferColor = 'rgba(199, 135, 40, 0.75)';
        this.bufferOutlineColor = '#c73828';
        this.nearbyLayers = {
            selection: 'Nearby Selection',
            assets: 'Nearby Assets',
            highlight: 'Nearby Highlight',
            mapPin: 'Nearby Pin'
        };
        this.nearbyTemplateFunction = 'NEARBY';
        this.getApplicationNearbyAssets(environment.appId);
    }
    NearbyService.prototype.getDocumentSources = function (node) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var request, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = node.data;
                        if (!(data.record && !data.documentLoaded)) return [3 /*break*/, 4];
                        if (!node.parent.data.layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.documentService.getLayerDocSources([node.parent.data.layerId])];
                    case 1:
                        request = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.documentService.getTableDocSources([node.parent.data.tableId])];
                    case 3:
                        request = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, request ? request[0].docSources : []];
                }
            });
        });
    };
    NearbyService.prototype.getDocuments = function (node, sources) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents, feature;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documents = [];
                        if (!sources.length) return [3 /*break*/, 2];
                        feature = this.getFeatureData(node);
                        return [4 /*yield*/, this.documentService.getDocuments(feature, sources)];
                    case 1:
                        // TODO: Is this call limited to 101 documents or 999? Remove the limit?
                        documents = _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, documents];
                }
            });
        });
    };
    NearbyService.prototype.getFeatureData = function (node) {
        var data = node.data;
        var attributes = data.columnList.map(function (columnName, idx) {
            return { columnName: columnName, value: data.record[idx] };
        });
        return { attributes: attributes };
    };
    NearbyService.prototype.addDocumentNodes = function (node, documents) {
        var _this = this;
        var indent = 2;
        if (documents && documents.length) {
            documents.forEach(function (doc) {
                var name = "" + doc.fileName;
                node.addChild(new NearbyAssetNode({ name: name, description: JSON.stringify(doc, undefined, indent), record: doc }));
            });
            var names = Object.keys(node.children[0].data.record);
            node.data.columns = names.map(function (name) {
                return { name: name, alias: _this.documentService.ecsAliases[name] };
            });
            node.data.documentLoaded = true;
            node.data.enabled = true;
        }
    };
    NearbyService.prototype.addRecordNodes = function (node, columnList, records) {
        var _this = this;
        var card = node.data.templates ? node.data.templates.filter(function (t) { return t.type === 'CARD' && t.functionType === _this.nearbyTemplateFunction; })[0] : null;
        var list = node.data.templates ? node.data.templates.filter(function (t) { return t.type === 'LIST' && t.functionType === _this.nearbyTemplateFunction; })[0] : null;
        var header = node.data.templates ? node.data.templates.filter(function (t) { return t.type === 'TITLE' && t.functionType === _this.nearbyTemplateFunction; })[0] : null;
        var deeplink = node.data.templates ? node.data.templates.filter(function (t) { return t.type === 'DEEPLINK' && t.functionType === _this.nearbyTemplateFunction; })[0] : null;
        records.forEach(function (record) {
            // TODO: Create a better default card template than stringify.
            var name = card ? _this.applyTemplate(card.format, card.layout, columnList, record) : JSON.stringify(record);
            var description = list ?
                _this.applyTemplate(list.format, list.layout, columnList, record) :
                columnList.filter(function (c) { return c !== 'GEOMETRY'; }).map(function (c, i) { return c.replace(/[-_.]/g, ' ') + ": " + record[i]; }).join('\n');
            var title = header ? _this.applyTemplate(header.format, header.layout, columnList, record) : name;
            var link = deeplink ? _this.applyTemplate(deeplink.format, deeplink.layout, columnList, record) : null;
            var recordNode = new NearbyAssetNode({ id: node.data.id, name: name, title: title, description: description, link: link, columnList: columnList, record: record });
            recordNode.enabled = true;
            node.addChild(recordNode);
        });
        return;
    };
    // TODO: Move the following code a common location (service?) usable by all of MC2
    NearbyService.prototype.applyTemplate = function (format, layout, columnList, values) {
        switch (format) {
            case 'TEXT':
                var regex = /\$\{(\w+)\}/g;
                var fieldStart_1 = 2;
                return layout.replace(regex, function (x) {
                    var idx = columnList.indexOf(x.slice(fieldStart_1, -1));
                    return (idx >= 0) ? values[idx] : '';
                });
                break;
            default:
                return layout;
        }
    };
    NearbyService.prototype.getApplicationNearbyAssets = function (appId, overwriteExistingValues) {
        if (overwriteExistingValues === void 0) { overwriteExistingValues = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.nearbyAssetsPromise || overwriteExistingValues) {
                    this.nearbyAssetsPromise = this.layerApi.getApplicationNearbyAssets(appId)
                        .then(function (apps) {
                        var assets = apps[0].nearbyAssets.map(function (a) { return ({
                            id: a.id,
                            parentId: a.parentId,
                            relationshipName: a.relationshipName,
                            layerId: a.layerId,
                            tableId: a.tableId,
                            parentJoinKey: a.parentJoinKey,
                            joinKey: a.joinKey,
                            templates: a.templates,
                            // TODO: Implement logic to handle * for columns; Not required for Nearby tool
                            columnList: !a.columnList || a.columnList.trim() === '*' ? [] : a.columnList.split(',').map(function (x) { return x.trim(); })
                        }); });
                        return assets;
                    });
                }
                return [2 /*return*/, this.nearbyAssetsPromise];
            });
        });
    };
    NearbyService.prototype.getNearbyLayer = function (title) {
        var layers = this.layerService.mapLayers.graphics.filter(function (x) { return x.title === title; });
        return layers.length ? layers[0] : null;
    };
    NearbyService.prototype.setNearbyLayer = function (title, graphics, removeLayer) {
        if (removeLayer === void 0) { removeLayer = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layer, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getNearbyLayer(title);
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title, hideInLegend: true })];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        layer = _a;
                        if (removeLayer) {
                            layer.removeAll();
                        }
                        if (graphics.length) {
                            layer.addMany(graphics);
                        }
                        // TODO: The title strings are in nearby.component. Should turn into a type and use that both places?
                        if (title === 'Nearby Pin') {
                            this.layerService.moveLayerToTheTop(layer);
                        }
                        else if (title === 'Nearby Selection') {
                            // TODO: This move to bottom might move it under polygons so that it can't be seen. Perhaps
                            //       this layer need to be on top but below the other nearby utility layers.
                            this.layerService.moveLayerToTheBottom(layer);
                        }
                        return [2 /*return*/, layer];
                }
            });
        });
    };
    NearbyService.prototype.removeNearbyLayer = function (title) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layer;
            return tslib_1.__generator(this, function (_a) {
                layer = this.getNearbyLayer(title);
                if (layer) {
                    layer.destroy();
                }
                return [2 /*return*/];
            });
        });
    };
    NearbyService.prototype.getBuffers = function (distance, distanceUnit, geometry) {
        if (geometry === void 0) { geometry = []; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var buffers, bufferOptions;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bufferOptions = {
                            unionResults: true,
                            distance: distance,
                            distanceUnit: distanceUnit,
                            areaUnit: 'square-miles',
                            fillType: 'solid',
                            fillColor: this.bufferColor,
                            // opacity: 0.1,
                            outlineType: 'solid',
                            outlineColor: this.bufferOutlineColor,
                            lineWidth: 2
                        };
                        return [4 /*yield*/, this.bufferService.getGeometryBuffers(geometry, bufferOptions)];
                    case 1:
                        buffers = _a.sent();
                        return [2 /*return*/, buffers];
                }
            });
        });
    };
    NearbyService.prototype.performSpatialQuery = function (layer, selection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!layer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.spatialQueryService.spatialQueryLayers(true, [layer], [selection])];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, this.spatialQueryService.getGuidQuery(results[0].guid, this.nearbyQueryName)];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    NearbyService.prototype.getJoinQuery = function (parentRecordNode, node) {
        var idx = parentRecordNode.data.columnList.indexOf(node.data.parentJoinKey);
        if (idx >= 0) {
            var query = {
                name: this.nearbyQueryName,
                field: node.data.joinKey,
                operator: '=',
                value: parentRecordNode.data.record[idx].toString()
            };
            return query;
        }
        return null;
    };
    NearbyService.prototype.findKeyParent = function (node) {
        var result = null;
        if (node.parent) {
            if (node.parent.data && node.parent.data.record) {
                result = node.parent;
            }
            else {
                result = this.findKeyParent(node.parent);
            }
        }
        return result;
    };
    NearbyService.prototype.updateLayerFilter = function (layer, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newQuery;
            return tslib_1.__generator(this, function (_a) {
                this.toSqlStringService.removeClauses(layer.mapcoreProps.query, { name: this.nearbyQueryName });
                newQuery = this.toSqlStringService.addFilter(layer.mapcoreProps.query, query);
                this.layerService.updateLayerFilter(layer, newQuery);
                return [2 /*return*/];
            });
        });
    };
    NearbyService.prototype.getLayerRecords = function (layer, fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var columns, records;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        records = [];
                        if (!layer) return [3 /*break*/, 2];
                        // TODO: Consider automatically adding GEOMETRY column to fieldNames if not
                        //       already in the field list because we will need it.
                        columns = this.filterColumns(layer.mapcoreProps.columns, fieldNames);
                        return [4 /*yield*/, this.layerApi.getData(layer.mapcoreProps.parentId, fieldNames, layer.mapcoreProps.query, this.maxRecordsFetched)];
                    case 1:
                        records = _a.sent();
                        _a.label = 2;
                    case 2:
                        columns.forEach(function (c) { return c.alias = c.alias.replace(/_/g, ' '); });
                        return [2 /*return*/, { columns: columns, records: records }];
                }
            });
        });
    };
    NearbyService.prototype.getTableRecords = function (tableId, query, fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var records, columns, filter, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        records = [];
                        columns = [];
                        filter = this.toSqlStringService.getSql(query);
                        return [4 /*yield*/, this.layerService.getTable(tableId, "id columns { name, alias, dataType, columnIdentifierId, databaseColumnOrder } records:data(fieldNames: [\"" + fieldNames + "\"], filter: \"" + filter + "\")")];
                    case 1:
                        results = _a.sent();
                        if (results && results.length) {
                            columns = this.filterColumns(results[0].columns, fieldNames);
                            records = results[0].records;
                        }
                        columns.forEach(function (c) { return c.alias = c.alias.replace(/_/g, ' '); });
                        return [2 /*return*/, { columns: columns, records: records }];
                }
            });
        });
    };
    NearbyService.prototype.filterColumns = function (columns, columnList) {
        var filtered = columns.filter(function (c) { return columnList.indexOf(c.name) >= 0; });
        var sorted = filtered.sort(function (a, b) { return columnList.indexOf(a.name) - columnList.indexOf(b.name); });
        return sorted;
    };
    NearbyService.prototype.getSortableColumns = function (node) {
        // TODO: Consider removing fileName, size, source, url as well as they are not that useful for grouping ECS documents.
        var results = node.data.columns ? node.data.columns.filter(function (c) { return c.name !== 'GEOMETRY'; }) : [];
        return results;
    };
    NearbyService.ngInjectableDef = i0.defineInjectable({ factory: function NearbyService_Factory() { return new NearbyService(i0.inject(i1.BufferService), i0.inject(i2.LayerApi), i0.inject(i3.LayerService), i0.inject(i4.SpatialQueryService), i0.inject(i5.ToSqlStringService), i0.inject(i6.DocumentService)); }, token: NearbyService, providedIn: "root" });
    return NearbyService;
}());
export { NearbyService };
